<span>You will also need at least one of these features: </span>
<app-chips
  class="u-display-inline-block"
  [label]="'Select at least one'"
  [form]="multiSelectFeature.get('feature_ids')"
  [options]="featureOptions"
  [displayField]="'name'"
  (optionChange)="onSelectFeature($event)"
></app-chips>
